import { defineComponent as j, mergeModels as F, useModel as y, ref as q, onMounted as L, watch as X, openBlock as h, createElementBlock as D, normalizeClass as G, renderSlot as x, createCommentVNode as z, createElementVNode as O, createVNode as l, unref as a, withCtx as d, createTextVNode as B, toDisplayString as V, normalizeProps as b, guardReactiveProps as A } from "vue";
import Y from "dayjs";
import p from "../Button/v-button.vue.js";
/* empty css                      */
import J from "../CalendarGrid/v-calendar-grid.vue.js";
/* empty css                                   */
import "@vueuse/core";
/* empty css                          */
import { VTextInput as K } from "../inputs/TextInput/index.js";
/* empty css                                                 */
import { MAX_DATE as Q } from "../../utils/date.js";
import { useDateClamp as U } from "../CalendarGrid/composables/date.js";
import { useCalendarBounds as Z } from "../CalendarGrid/composables/useCalendarBounds.js";
import { CALENDAR_VIEW_MODE as c } from "../CalendarGrid/enum.js";
/* empty css                   */
/* empty css                             */
import C from "../Icon/v-icon.vue.js";
/* empty css                  */
/* empty css                                 */
/* empty css                                           */
/* empty css                                                   */
/* empty css                                    */
/* empty css                                  */
/* empty css                                    */
/* empty css                                   */
/* empty css                               */
/* empty css                                              */
const ee = {
  key: 0,
  class: "date-select-header"
}, oe = { class: "v-date-select-nav" }, te = { class: "v-date-select-footer" }, ae = ["value", "name"], xe = /* @__PURE__ */ j({
  __name: "v-date-select",
  props: /* @__PURE__ */ F({
    minDate: { default: () => Y(0) },
    maxDate: { default: () => Y(Q) },
    dateFormat: { default: "YYYY-MM-DD" },
    navColor: {},
    color: {},
    name: {},
    normalize: { type: Function, default: (f) => f.startOf("day") },
    disallowClear: { type: Boolean },
    disallow: {},
    classes: {},
    is: { default: "div" }
  }, {
    modelValue: {},
    modelModifiers: {},
    text: {},
    textModifiers: {},
    view: {
      default: () => Y()
    },
    viewModifiers: {}
  }),
  emits: /* @__PURE__ */ F(["change"], ["update:modelValue", "update:text", "update:view"]),
  setup(f, { emit: S }) {
    var N;
    const t = f, i = y(f, "modelValue"), u = y(f, "text"), m = y(f, "view"), $ = S;
    u.value || (u.value = ((N = i.value) == null ? void 0 : N.format(t.dateFormat)) ?? "");
    const s = q(c.MONTH);
    function k() {
      u.value = "", !t.disallowClear && (i.value = void 0);
    }
    function H(e) {
      const [o, r] = Z(m.value);
      return e.valueOf() >= o.valueOf() && e.valueOf() <= r.valueOf();
    }
    function M(e, o = !1) {
      !e || !o && H(e) || (m.value = U(e, t.minDate, t.maxDate));
    }
    function g(e) {
      T(e) && (i.value = t.normalize(e), $("change", e));
    }
    function I(e) {
      if (u.value = e, e === "")
        k();
      else {
        const o = Y(e, t.dateFormat);
        o.isValid() && g(o);
      }
    }
    function P(e) {
      u.value = (e == null ? void 0 : e.format(t.dateFormat)) ?? "";
    }
    function R() {
      s.value === c.MONTH ? s.value = c.YEAR : s.value === c.YEAR && (s.value = c.MONTH);
    }
    function _(e) {
      const o = e.target.value;
      I(o);
    }
    function T(e) {
      var w;
      if ((w = t.disallow) == null ? void 0 : w.call(t, e)) return !1;
      const r = e.valueOf(), n = t.minDate.valueOf(), v = t.maxDate.valueOf();
      return r >= n && r <= v;
    }
    function W(e) {
      return i.value && t.normalize(e).isSame(i.value);
    }
    function E(e, o = {}) {
      const r = t.classes ? t.classes(e) : {};
      return {
        onClick: () => g(e),
        name: t.name,
        title: e.format(t.dateFormat),
        disabled: !T(e),
        // value: value.toISOString(),
        class: {
          "v-calendar-day-btn": !0,
          selected: W(e),
          ...o,
          ...r
        }
      };
    }
    return L(() => {
      const e = i.value;
      if (!e) return;
      const o = t.normalize(e);
      e.valueOf() !== o.valueOf() && (i.value = o);
    }), X(i, (e) => {
      M(e), P(e);
    }), (e, o) => {
      var r;
      return h(), D("div", {
        class: G(["v-date-select", e.color])
      }, [
        e.$slots.title ? (h(), D("header", ee, [
          x(e.$slots, "title")
        ])) : z("", !0),
        O("nav", oe, [
          l(a(p), {
            class: "v-date-select-button",
            color: e.navColor ?? e.color,
            onClick: R
          }, {
            prefix: d(() => [
              l(a(C), { i: "calendar-days" })
            ]),
            default: d(() => [
              B(" " + V(m.value.format(s.value == a(c).MONTH ? "YYYY. MMMM" : "YYYY")), 1)
            ]),
            _: 1
          }, 8, ["color"]),
          l(a(p), {
            onClick: o[0] || (o[0] = () => M(m.value.add(-1, s.value), !0)),
            color: e.navColor ?? e.color
          }, {
            default: d(() => [
              l(a(C), { i: "chevron-up" })
            ]),
            _: 1
          }, 8, ["color"]),
          l(a(p), {
            onClick: o[1] || (o[1] = () => M(m.value.add(1, s.value), !0)),
            color: e.navColor ?? e.color
          }, {
            default: d(() => [
              l(a(C), { i: "chevron-down" })
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        l(a(J), {
          "view-date": m.value,
          elevation: "1",
          mode: s.value
        }, {
          month: d(({ value: n }) => [
            l(a(p), {
              class: "v-calendar-grid-item",
              onClick: o[2] || (o[2] = (v, w) => {
                M(w, !0), s.value = a(c).MONTH;
              }),
              value: n,
              variant: m.value.isSame(n, "month") ? "filled" : "link",
              square: "",
              size: "sm"
            }, {
              default: d(() => [
                B(V(n.format("YYYY. MMM.")), 1)
              ]),
              _: 2
            }, 1032, ["value", "variant"])
          ]),
          day: d(({ value: n, isOutside: v }) => [
            x(e.$slots, "day", b(A({ btnProps: E(n, { outside: v }), value: n })), () => [
              O("button", b(A(E(n, { outside: v }))), V(n.date()), 17)
            ])
          ]),
          _: 3
        }, 8, ["view-date", "mode"]),
        O("footer", te, [
          l(a(K), {
            type: "text",
            placeholder: e.dateFormat,
            "model-value": u.value,
            onInput: _,
            class: "v-date-select-input"
          }, {
            prefix: d(() => [
              l(a(C), { i: "calendar-day" })
            ]),
            _: 1
          }, 8, ["placeholder", "model-value"]),
          l(a(p), {
            onClick: k,
            color: e.navColor ?? e.color,
            disabled: i.value == null || u.value == ""
          }, {
            default: d(() => [
              l(a(C), { i: "close" })
            ]),
            _: 1
          }, 8, ["color", "disabled"])
        ]),
        e.name ? (h(), D("input", {
          key: 1,
          type: "text",
          value: (r = i.value) == null ? void 0 : r.toISOString(),
          readonly: "",
          hidden: "",
          name: e.name
        }, null, 8, ae)) : z("", !0)
      ], 2);
    };
  }
});
export {
  xe as default
};
